import { ChangeDetectionStrategy, Component } from "@angular/core";

/* eslint-disable @tseslint/no-extraneous-class */
@Component({
  selector: "app-authenticate-ui-headline-description",
  templateUrl: "headline-description.component.html",
  styleUrl: "headline-description.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class HeadlineDescriptionComponent {}
/* eslint-enable @tseslint/no-extraneous-class */
